import { createRouter, createWebHashHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Question from '../views/Question.vue'
import Result from '../views/Result.vue'
const router = createRouter({
  history: createWebHashHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/question',
      name: 'question',
      component: Question
    },
    {
      path: '/result',
      name: 'result',
      component: Result
    },
  ]
})
router.beforeEach((to, from ,next) => {
  if (to.path !== '/') {
    !window.id && next('/');
  }
  next();
})
export default router
